<template>
  <div class="module-hot-area" :style="{height: viewHeight + 'px'}">
    <img v-if="content.img_url" :src="content.img_url" class="hot-area-img" @load="setImageRatio" />
    <img v-else src="../../assets/images/icon-bg8.jpg" class="hot-area-img" @load="setImageRatio" />
    <div
      class="hot-area-item"
      v-for="(item, index) in areas"
      :key="index"
      :style="areaStyle(item)">
      {{ index + 1 }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: {}
    },
    data () {
      return {
        imageRatio: 0.5
      }
    },
    computed: {
      viewHeight () {
        return Math.round(298 * this.imageRatio)
      },
      areas () {
        return Array.isArray(this.content.areas) ? this.content.areas : []
      }
    },
    methods: {
      setImageRatio (event) {
        var image = event.target
        if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
          this.imageRatio = image.naturalHeight / image.naturalWidth
        }
      },
      areaStyle (item) {
        return {
          left: (item.x || 0) + '%',
          top: (item.y || 0) + '%',
          width: (item.width || 0) + '%',
          height: (item.height || 0) + '%'
        }
      }
    }
  }
</script>

<style scoped>
  .module-hot-area {
    position: relative;
    width: 298px;
    overflow: hidden;
    background-color: #f8f8f8;
  }
  .hot-area-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .hot-area-item {
    position: absolute;
    box-sizing: border-box;
    border: 1px dashed #ff4d4f;
    background-color: rgba(255, 77, 79, 0.18);
    color: #ff4d4f;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    pointer-events: none;
  }
</style>
